// @ts-nocheck
import 'zone.js';

import 'core-js/features/url';

import 'reflect-metadata';

// @ts-ignore
window.global = window;
